import type {Item} from '@PosterWhiteboard/items/item/item.class';

const CYCLE_DURATION_MS = 4500;
const FRAME_INTERVAL_MS = 50;

const loadingItems = new Set<Item>();
let rafId: number | null = null;
let lastPaintTime = 0;

export const getLoadingPhase = (): number => {
  return (performance.now() % CYCLE_DURATION_MS) / CYCLE_DURATION_MS;
};

const tick = (time: number): void => {
  if (time - lastPaintTime >= FRAME_INTERVAL_MS) {
    lastPaintTime = time;
    loadingItems.forEach((item) => {
      item.renderDecorations.invalidate();
    });
  }
  rafId = requestAnimationFrame(tick);
};

export const registerLoadingItem = (item: Item): void => {
  loadingItems.add(item);
  rafId ??= requestAnimationFrame(tick);
};

export const deregisterLoadingItem = (item: Item): void => {
  loadingItems.delete(item);
  if (loadingItems.size === 0 && rafId !== null) {
    cancelAnimationFrame(rafId);
    rafId = null;
    lastPaintTime = 0;
  }
};
